export default {
  Landscape: 0,
  Portrait: 1
}
